<template>
  <aside class="page-sidebar-mobile-container">
    <div
      class="page-sidebar-mobile-overlay"
      :class="{ active: show }"
      @click="toggleMenu(false)"
    ></div>

    <div
      class="page-sidebar-mobile d-flex flex-column d-lg-none"
      :class="{ active: show }"
    >
      <div class="header d-flex align-items-center">
        <b-avatar
          class="avatar"
          src="https://assets.admin.wize.pe/images/dropdown-user-avatar.svg"
        >
        </b-avatar>
        <div class="d-flex flex-column pl-3">
          <span class="user-name">{{ username }}</span>
          <span class="email d-inline-block mt-1">{{ user.email }}</span>
        </div>
      </div>

      <div class="grid mt-2 px-2">
        <router-link
          :to="{ name: 'celulares-dashboard' }"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: $route.name === 'celulares-dashboard' }"
        >
          <span class="menu-icon">
            <i class="ri-home-5-line"></i>
          </span>

          Portada
        </router-link>

        <button
          type="button"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: isStatusRoute }"
          v-if="$can('manage', 'status_pago_lista') ||
             $can('manage', 'status_pago_carga_base') ||
             $can('manage', 'status_pago_carga_abonos')"
          @click="setSelection('status')"
        >
          <span class="menu-icon">
            <i class="ri-wallet-2-line"></i>
          </span>

          Status de pago
        </button>

        <!-- <router-link
          :to="{ name: 'celulares-base-batch' }"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: $route.name === 'celulares-base-batch' }"
        >
          <span class="menu-icon">
            <i class="ri-bank-card-line"></i>
          </span>

          Carga base
        </router-link> -->

        <!-- <router-link
          :to="{ name: 'celulares-status' }"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: $route.name === 'celulares-status' }"
        >
          <span class="menu-icon">
            <i class="ri-bank-card-line"></i>
          </span>

          Status de pago
        </router-link> -->

        <button
          type="button"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: isMaintenanceRoute }"
          v-if="$can('manage', 'mantenimiento_clusters') || $can('manage', 'mantenimiento_zonales') || $can('manage', 'mantenimiento_tipos')"
          @click="setSelection('maintenance')"
        >
          <span class="menu-icon">
            <i class="ri-edit-line"></i>
          </span>

          Mantenimiento
        </button>

        <button
          type="button"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: isRolesRoute }"
          v-if="$can('manage', 'cargos_jefes_ventas') || $can('manage', 'cargos_supervisores') || $can('manage', 'cargos_vendedores')"
          @click="setSelection('roles')"
        >
          <span class="menu-icon">
            <i class="ri-government-line"></i>
          </span>

          Cargos
        </button>

        <button
          type="button"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: isSalesPointsRoute }"
          v-if="$can('manage', 'pdv_lista') || $can('manage', 'pdv_carga_masiva')"
          @click="setSelection('sales-points')"
        >
          <span class="menu-icon">
            <i class="ri-store-line"></i>
          </span>

          Puntos de venta
        </button>

        <button
          type="button"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: isPushersRoute }"
          v-if="$can('manage', 'impulsador_lista')"
          @click="setSelection('pushers')"
        >
          <span class="menu-icon">
            <i class="ri-user-star-line"></i>
          </span>

          Impulsadores
        </button>

        <router-link
          :to="{ name: 'celulares-code-relations-list' }"
          v-if="$can('manage', 'relaciones_codigo')"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: $route.name === 'celulares-code-relations-list' }"
        >
          <span class="menu-icon">
            <i class="ri-article-line"></i>
          </span>

          Relaciones de códigos
        </router-link>

        <router-link
          :to="{ name: 'celulares-schemes-list' }"
          v-if="$can('manage', 'esquema')"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: $route.name === 'celulares-schemes-list' }"
        >
          <span class="menu-icon">
            <i class="ri-donut-chart-line"></i>
          </span>

          Esquemas
        </router-link>

        <!-- <router-link
          :to="{ name: 'celulares-accelators-list' }"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: $route.name === 'celulares-accelators-list' }"
        >
          <span class="menu-icon">
            <i class="ri-bubble-chart-line"></i>
          </span>

          Aceleradores
        </router-link> -->

        <router-link
          :to="{ name: 'celulares-ad-audit-log' }"
          v-if="$can('manage', 'auditoria_lista')"
          class="link d-flex flex-column justify-content-center align-items-center text-white text-center"
          :class="{ active: $route.name === 'celulares-ad-audit-log' }"
        >
          <span class="menu-icon">
            <i class="ri-edit-line"></i>
          </span>

          Auditorías
        </router-link>
      </div>

      <div class="menu-list-container">
        <ul class="menu-list list-unstyled" v-if="selection">
          <li v-for="item in getMenuItems" :key="item.text">
            <router-link
              :to="item.route"
              exact-active-class="active"
              v-if="$can('manage', item.role)"
              class="menu-subitem text-decoration-none"
              ><BulletIcon class="fill-white mr-3" />{{
                item.text
              }}</router-link
            >
          </li>
        </ul>
      </div>

      <button
        type="button"
        class="menu-option d-flex align-items-center"
        @click="logout()"
      >
        <LogoutIcon class="fill-white mr-4" />

        <span class="sidebar-item-text">Cerrar sesión</span>
      </button>

      <div
        class="menu-option classic version d-flex justify-content-between align-items-center"
      >
        <span class="text">V{{ version }} {{ year }}</span>
        <p class="my-0">
          Forjado por <a href="https://wize.pe" target="_blank">Wize</a>
        </p>
      </div>
    </div>
  </aside>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { Constants as LocalConstants } from "@/core/utils";
import { BulletIcon, LogoutIcon, Helpers, LocalStorage } from "wize-admin";
import { SecurityService } from "@/core/services";

export default {
  name: "PageSidebarMobile",
  data() {
    return {
      LocalConstants,
      version: process.env.PACKAGE_VERSION,
      year: new Date().getFullYear(),
      selection: "",
      menuList: [
        {
          key: "home",
        },
        {
          key: "status",
          list: [
            {
              role: 'status_pago_lista',
              route: { name: "celulares-status" },
              text: "Lista",
            },
            {
              role: 'status_pago_carga_base',
              route: { name: "celulares-base-batch" },
              text: "Cargar base",
            },
            {
              role: 'status_pago_carga_abonos',
              route: { name: "celulares-status-made-batch-list" },
              text: "Cargar abonos",
            },
          ],
        },
        {
          key: "maintenance",
          list: [
            {
              role: 'mantenimiento_clusters',
              route: { name: "celulares-config-cluster-list" },
              text: "Clústers",
            },
            {
              role: 'mantenimiento_zonales',
              route: { name: "celulares-config-zonal-list" },
              text: "Zonales",
            },
            {
              role: 'mantenimiento_tipos',
              route: { name: "celulares-config-types-list" },
              text: "Tipos",
            },
          ],
        },
        {
          key: "roles",
          list: [
            {
              role: 'cargos_jefes_ventas',
              route: { name: "celulares-managers-list" },
              text: "Jefes de ventas",
            },
            {
              role: 'cargos_supervisores',
              route: { name: "celulares-supervisors-list" },
              text: "Supervisores",
            },
            {
              role: 'cargos_vendedores',
              route: { name: "celulares-sellers-list" },
              text: "Vendedores",
            },
          ],
        },
        {
          key: "sales-points",
          list: [
            {
              role: 'pdv_lista',
              route: { name: "celulares-sales-points-list" },
              text: "Lista",
            },
            {
              role: 'pdv_carga_masiva',
              route: { name: "celulares-sales-points-upload" },
              text: "Carga masiva",
            },
          ],
        },
        {
          key: "pushers",
          list: [
            {
              route: { name: "celulares-pushers-list" },
              role: 'impulsador_lista',
              text: "Lista",
            },
            {
              route: { name: "celulares-pushers-upload" },
              role: 'impulsador_carga_masiva',
              text: "Carga masiva",
            },
          ],
        },
      ],
    };
  },
  mounted() {
    this.setSelection(this.$route.name);
  },
  props: {
    show: Boolean,
  },
  components: {
    BulletIcon,
    LogoutIcon,
  },
  watch: {
    "$route.name": function () {
      if (this.currentDevice != "desktop") {
        this.toggleMenu(false);
      }
    },
  },
  methods: {
    ...mapMutations({
      toggleMenu: "app/toggleMenu",
    }),
    setSelection(key) {
      this.selection = key;
    },
    async logout() {
      try {
        await this.$store.dispatch("app/loading", true);
        await SecurityService.logout({refreshToken: LocalStorage.getRefreshToken()})
      } catch (error) {
        console.error(error)
      } finally {
        await this.$store.dispatch("app/loading", false);
        this.$store.dispatch("auth/logout").then(() => this.$router.push({name: "login"}));
      }
    },
  },
  computed: {
    ...mapGetters({
      user: "auth/getUser",
      isMenuOpen: "app/isMenuOpen",
      currentDevice: "app/getCurrentDevice",
    }),
    username: function () {
      return Helpers.capitalizeName(this.user.name);
    },
    getMenuItems() {
      let item = this.menuList.find((item) => item.key === this.selection);
      return item ? item.list : [];
    },
    isMaintenanceRoute() {
      let routes = ["mantenimiento"];
      return (
        routes.some((str) => this.$route.name.includes(str)) ||
        routes.some((str) => this.selection.includes(str))
      );
    },
    isStatusRoute() {
      let routes = ["status"];
      return (
        routes.some((str) => this.$route.name.includes(str)) ||
        routes.some((str) => this.selection.includes(str))
      );
    },
    isSalesPointsRoute() {
      let routes = ["puntos-de-venta"];
      return (
        routes.some((str) => this.$route.name.includes(str)) ||
        routes.some((str) => this.selection.includes(str))
      );
    },
    isRolesRoute() {
      let routes = ["cargos"];
      return (
        routes.some((str) => this.$route.name.includes(str)) ||
        routes.some((str) => this.selection.includes(str))
      );
    },
    isPushersRoute() {
      let routes = ["impulsadores"];
      return (
        routes.some((str) => this.$route.name.includes(str)) ||
        routes.some((str) => this.selection.includes(str))
      );
    },
  },
};
</script>

<style lang="stylus">
@import "../../Styles/components/layout/page-sidebar-mobile.styl"
</style>
